import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1129.4317,113 L1129.4317,1807.14754 L903.545357,1807.14754 L451.772678,1355.37487 L451.772678,564.772678 L903.545357,113 L1129.4317,113 Z M1671.9768,361.057083 C1832.01727,521.097555 1920,733.882486 1920,960.107655 C1920,1186.33282 1832.01727,1399.00481 1671.9768,1559.04528 L1671.9768,1559.04528 L1592.12598,1479.19446 C1730.82019,1340.61319 1807.05683,1156.177 1807.05683,960.107655 C1807.05683,763.925369 1730.82019,579.602117 1592.12598,440.907904 L1592.12598,440.907904 Z M338.829509,564.772678 L338.829509,1355.37487 L169.414754,1355.37487 C75.6719236,1355.37487 0,1279.70294 0,1185.96011 L0,1185.96011 L0,734.187433 C0,640.444602 75.6719236,564.772678 169.414754,564.772678 L169.414754,564.772678 L338.829509,564.772678 Z M1432.75187,600.858021 C1528.52768,697.876204 1581.1592,825.501985 1581.1592,960.0173 C1581.1592,1094.64556 1528.52768,1222.27134 1432.75187,1319.28952 L1432.75187,1319.28952 L1352.44928,1240.11636 C1427.10471,1164.21855 1468.21603,1064.71562 1468.21603,960.0173 C1468.21603,855.431925 1427.10471,755.928993 1352.44928,680.031183 L1352.44928,680.031183 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAudioSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconAudioSolid, _Component);

  var _super = _createSuper(IconAudioSolid);

  function IconAudioSolid() {
    _classCallCheck(this, IconAudioSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconAudioSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAudio",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconAudioSolid.displayName = "IconAudioSolid";
  return IconAudioSolid;
}(Component);

IconAudioSolid.glyphName = 'audio';
IconAudioSolid.variant = 'Solid';
IconAudioSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAudioSolid;
export { IconAudioSolid };